import { EVENTS } from '../constants/webSocketConsts/events';
import {
  setMessageSettingsAction,
  removeMessageSettingsAction,
} from '../store/settings/actions';

export const MessageSettingsHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return setMessageSettingsAction(items);
    case EVENTS.REMOVE:
      return removeMessageSettingsAction(items);
    default:
      break;
  }
  return null;
};
